export default "__VITE_ASSET__Dkl09XYx__"